import MUIContainer from "@mui/material/Container";

const Container = MUIContainer;

export default Container;
